module.exports = {
	"lan": [
		"cn",
		"en",
		"fr"
	],
	"default": "cn",
	"data": {
		"title": {
			"cn": "俄罗斯方块",
			"en": "T E T R I S",
			"fr": "T E T R I S"
		},
		"github": {
			"cn": "GitHub",
			"en": "GitHub",
			"fr": "GitHub"
		},
		"linkTitle": {
			"cn": "查看源代码",
			"en": "View data source",
			"fr": "Afficher la source des données"
		},
		"QRCode": {
			"cn": "二维码",
			"en": "QR code",
			"fr": "QR code"
		},
		"QRNotice": {
			"cn": "扫一扫用手机玩",
			"en": "Scan QR code to play with a mobile phone",
			"fr": "Numérisez le code QR pour jouer avec un téléphone mobile"
		},
		"titleCenter": {
			"cn": "俄罗斯方块<br />TETRIS",
			"en": "TETRIS",
			"fr": "TETRIS"
		},
		"point": {
			"cn": "得分",
			"en": "Point",
			"fr": "Score"
		},
		"highestScore": {
			"cn": "最高分",
			"en": "Max",
			"fr": "Max"
		},
		"lastRound": {
			"cn": "上轮得分",
			"en": "Last Round",
			"fr": "Dernier Tour"
		},
		"cleans": {
			"cn": "消除行",
			"en": "Cleans",
			"fr": "Lignes"
		},
		"level": {
			"cn": "级别",
			"en": "Level",
			"fr": "Difficulté"
		},
		"startLine": {
			"cn": "起始行",
			"en": "Start Line",
			"fr": "Ligne Départ"
		},
		"next": {
			"cn": "下一个",
			"en": "Next",
			"fr": "Prochain"
		},
		"pause": {
			"cn": "暂停",
			"en": "Pause",
			"fr": "Pause"
		},
		"sound": {
			"cn": "音效",
			"en": "Sound",
			"fr": "Sonore"
		},
		"reset": {
			"cn": "重玩",
			"en": "Reset",
			"fr": "Réinitialiser"
		},
		"rotation": {
			"cn": "旋转",
			"en": "Rotation",
			"fr": "Rotation"
		},
		"left": {
			"cn": "左移",
			"en": "Left",
			"fr": "Gauche"
		},
		"right": {
			"cn": "右移",
			"en": "Right",
			"fr": "Droite"
		},
		"down": {
			"cn": "下移",
			"en": "Down",
			"fr": "Bas"
		},
		"drop": {
			"cn": "掉落",
			"en": "Drop",
			"fr": "Tomber"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n.json
// module id = 143
// module chunks = 1